import React, { useState, useEffect } from 'react';
import './Accountability.css'
import { MdStore } from "react-icons/md";
import { FaSquare, FaPiggyBank, FaUserClock, FaCoins } from "react-icons/fa";
import {  RiSwordFill  } from "react-icons/ri";
import { IoPersonAdd } from "react-icons/io5";


import { AiFillSecurityScan, AiFillSafetyCertificate  } from "react-icons/ai";
import { BsShieldFillExclamation } from "react-icons/bs";
import { GiSwordsEmblem, GiPayMoney, GiCash } from "react-icons/gi";
import { SiCyberdefenders } from "react-icons/si";
import { LuCalendarClock } from "react-icons/lu";
import { FaMoneyBillWave } from "react-icons/fa";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdOutlineCenterFocusWeak } from "react-icons/md";
import { PiStrategyBold, PiIdentificationCardFill } from "react-icons/pi";
import { FaUniversalAccess } from "react-icons/fa6";
import { ImConfused2 } from "react-icons/im";
import { HiMiniUserGroup } from "react-icons/hi2";
import { GrCompliance } from "react-icons/gr";






const Accountability = () => {
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [isDashModalOpen, setIsDashModalOpen] = useState(false);

    const goals = [
        {
            goal: 'Impact Assessment',
            PreGoal:'Goal A1:',
            description: null,
            appliesTo: 'All AI systems',
            requirements: [
                {
                    id: 'A1.1',
                    text: 'Assess the impact of the system on people, organizations, and society by completing an Impact Assessment early in the system’s development, typically when defining the product vision and requirements. Document the effort using the Impact Assessment template. ',
                    tags: ['Impact Assessment']
                },
                {
                    id: 'A1.2',
                    text: 'Review the completed Impact Assessment with the reviewers identified according to your organization’s compliance process before development starts. Secure all required approvals from those reviewers. ',
                    tags: ['Impact Assessment']
                },
                {
                    id: 'A1.3',
                    text: 'Update and review the Impact Assessment at least annually, when new intended uses are added, and before advancing to a new release stage.',
                    tags: ['Impact Assessment']
                }
            ]
        },
        {
            goal:'Oversight of significant adverse impacts',
            PreGoal: 'Goal A2:',
            description: 'AI systems are reviewed to identify systems that may have a significant adverse impact on people, organizations, and society, and additional oversight and requirements are applied to those systems.',
            appliesTo: 'All AI systems',
            requirements: [
                {
                    id:'A2.1',
                    text: 'Review defined Restricted Uses to determine whether the system meets the definition of any Restricted Use. If it does, document this in the Impact Assessment, and follow the requirements for the Restricted Use.',
                    tags: ['Impact Assessment']
                },
                {
                    id:'A2.2',
                    text: 'Answer prompts in the Impact Assessment template to determine whether the system meets the definition of a Sensitive Use. If it does, report it to the Office of Responsible AI, and follow any additional requirements resulting from a Sensitive Uses review.',
                    tags: ['Impact Assessment']
                },
                {
                    id:'A2.3',
                    text: 'Review your systems at least annually against the definitions for Sensitive Uses and Restricted Uses. If there are systems that meet the criteria for Sensitive Uses, report them to the Responsible person(s) and/or reporting authority. If there are systems that meet the criteria for Restricted Uses, notify the same Responsible person(s) and/or reporting authority.',
                    tags: ['Impact Assessment']
                },
            ]
        },
        {
            goal:'Fit for purpose',
            PreGoal: 'Goal A3:',
            description: 'AI systems are fit for purpose in the sense that they provide valid solutions for the problems they are designed to solve.',
            appliesTo: 'All AI systems',
            requirements: [
                {
                    id:'A3.1',
                    text: 'Document in the Impact Assessment how the system’s use will solve the problem posed by each intended use, recognizing that there may be multiple valid ways in which to solve the problem.',
                    tags: ['Impact Assessment']
                },
                {
                    id:'A3.2',
                    text: 'Define and document for each model in the AI system:',
                    subRequirements: [
                        "the model’s proposed inputs and how well they represent the concepts they are intended to represent; include analysis of the limitations of this representation,",
                        "the model’s proposed output and how well it represents the concept it is intended to represent; include analysis of the limitations of this representation, and",
                        "limitations to the generalizability of the resulting model based on the training and testing data that will be used."
                    ],
                    tags: null
                },
                {
                    id:'A3.3',
                    text: 'Define and document Responsible Release Criteria for this Goal. Include:',
                    subRequirements: [
                        "a concise definition of the problem being solved in the intended use,",
                        "performance metrics and their Responsible Release Criteria, and",
                        "error types and their Responsible Release Criteria."
                    ],
                    tags: null
                },
                {
                    id:'A3.4',
                    text: 'Document an evaluation plan for each of the performance metrics and error types.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id:'A3.5',
                    text: 'Use the methods defined in requirement A3.4 to conduct evaluations. Document the pre-release results of the evaluations. Determine and document how often ongoing evaluation should be conducted to continue supporting this Goal.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id:'A3.6',
                    text: 'Provide documentation to customers which describes the system’s:',
                    subRequirements: [
                        "intended uses, and",
                        "evidence that the system is fit for purpose for each intended use.",
                    ],
                    text2: 'When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                    tags: ['Transparency Note.']
                },
                {
                    id:'A3.7',
                    text: 'If an intended use is not supported by evidence, or if evidence comes to light that refutes that the system is fit for purpose for the intended use at any point in the system’s use:',
                    subRequirements: [
                        "remove the intended use from customer-facing materials and make current customers aware of the issue, take action to close the identified gap, or discontinue the system,",
                        "revise documentation related to the intended use, and",
                        "publish the revised documentation to customers.",
                    ],
                    text2: 'When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                    tags: null
                },
                {
                    id:'A3.8',
                    text: 'Communicate with care about system benefits; follow any applicable guidance from your legal representatives.',
                    tags: null
                },

            ]
        },
        {
          goal: 'Data governance and management',
          PreGoal:'Goal A4:',
          description: 'AI systems are subject to appropriate data governance and management practices.',
          appliesTo: 'All AI systems',
          requirements: [
              {
                  id: 'A4.1',
                  text: 'Define and document data requirements with respect to the system’s intended uses, stakeholders, and the geographic areas where the system will be deployed. Document these requirements in the Impact Assessment. ',
                  tags: ['Impact Assessment']
              },
              {
                  id: 'A4.2',
                  text: 'Define and document procedures for the collection and processing of data, to include annotation, labelling, cleaning, enrichment, and aggregation, where relevant.',
                  tags: null
              },
              {
                  id: 'A4.3',
                  text: 'If you plan to use existing data sets to train the system, assess the quantity and suitability of available data sets that will be needed by the system in relation to the data requirements defined in A4.1. Document this assessment in the Impact Assessment.',
                  tags: ['Impact Assessment']
              },
              {
                  id: 'A4.4',
                  text: 'Define and document methods for evaluating data to be used by the system against the requirements defined in A4.1.',
                  tags: null
              },
              {
                  id: 'A4.5',
                  text: 'Evaluate all data sets using the methods defined in requirement A4.4. Document the results of the evaluation',
                  tags: null
              },
          ]
      },
      {
          goal: 'Human oversight and control',
          PreGoal:'Goal A5:',
          description: 'AI systems include capabilities that support informed human oversight and control.',
          appliesTo: 'All AI systems',
          requirements: [
              {
                  id: 'A5.1',
                  text: 'Identify the stakeholders who are responsible for troubleshooting, managing, operating, overseeing, and controlling the system during and after deployment. Document these stakeholders and their oversight and control responsibilities using the Impact Assessment template.',
                  tags: ['Impact Assessment']
              },
              {
                  id: 'A5.2',
                  text: 'Identify the system elements (including system UX, features, alerting and reporting functions, and educational materials) necessary for stakeholders identified in requirement A5.1 to effectively understand their oversight responsibilities and carry them out. Stakeholders must be able to understand:',
                  subRequirements: [
                    "the system’s intended uses,",
                    "how to effectively execute interactions with the system,",
                    "how to interpret system behaviour,",
                    "when and how to override, intervene, or interrupt the system, and",
                    "how to remain aware of the possible tendency of over-relying on outputs produced by the system (“automation bias”).",
                  ],
                  text2: 'Document the system design elements that will support relevant stakeholders for each oversight and control function.',
                  tags: null
              },
              {
                  id: 'A5.3',
                  text: 'When possible, design the system elements identified in A5.2. When this is not possible (for example, when the organisation is not responsible for the system UX), provide guidance on human oversight considerations to the third party responsible for implementing the system elements identified in A5.2.',
                  tags: null
              },
              {
                  id: 'A5.4',
                  text: 'Define and document the method to be used to evaluate whether each oversight or control function can be accomplished by stakeholders in realistic conditions of system use. Include the metrics or rubrics that will be used in the evaluations. When this is not possible (for example, when the organisation is not responsible for oversight and control functions), provide guidance on evaluating oversight and control functions to the third party responsible for evaluating oversight or control functions.',
                  tags: null
              },
              {
                  id: 'A5.5',
                  text: 'Define and document Responsible Release Criteria to achieve this Goal.',
                  tags: null
              },
              {
                  id: 'A5.6',
                  text: 'Conduct evaluations defined by requirement A5.4 using a near-release version of the system. Document the results.',
                  tags: null
              },
              {
                  id: 'A5.7',
                  text: 'If there are Responsible Release Criteria for metrics or rubrics that have not been met, consult with the reviewers named in the Impact Assessment, and in the case of Sensitive Uses, with the Office of Responsible AI, to develop a plan detailing how the gap will be managed until it can be closed. Document that plan.',
                  tags: null
              },
          ]
      },
    ];
 

  // Modal component
  const DashModal = ({ isOpen, onClose, selectedGroup }) => {
    if (!isOpen || !selectedGroup) return null;
  
    // Fetch the specific goal data based on `selectedGroup`
    const goalData = goals.find(goal => goal.goal === selectedGroup);
  
    if (!goalData) return null;
  
    return (
      <div className="dashModal">
        <div className="dashModalContent">
          <div className="dashModalBox">
            {/* Title Section */}
            <h2 className="goal-title">
              <span className="goal-prefix">{goalData.PreGoal}</span> <span className="goal-name">{goalData.goal}</span>
            </h2>
            <p className="applies-to">{goalData.description}</p>
            <p className="applies-to"><i>Applies to:</i> {goalData.appliesTo}</p>           
            {/* Requirements Table */}
            <div className="assessmentContainerBox">
              <table className="assessment-table">
                <thead>
                  <tr>
                    <th className="requirements-header">Requirements</th>
                  </tr>
                </thead>
                <tbody>
                  {goalData.requirements.map((requirement, index) => (
                    <tr key={index} className="requirement-row">
                      <td className="requirement-text">
                        <strong>{requirement.id}</strong> {requirement.text}
                        {requirement.subRequirements && (
                            <ul className="sub-requirements-list">
                            {requirement.subRequirements.map((subRequirement, subIndex) => (
                                <li key={subIndex} className="sub-requirement-item">
                                {subRequirement}
                                </li>
                            ))}
                            </ul>
                        )}
                        {requirement.text2}
                        {requirement.tags && requirement.tags.length > 0 && (
                            <p className="tags">
                            <strong>Tags:</strong> {requirement.tags.join(', ')}
                            </p>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
  
            {/* Close Button */}
            <button className="closeButton" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    );
  };
  


  // Handle modal opening
  const openModal = (group) => {
    console.log(`Opening modal for: ${group}`);
    setSelectedGroup(group);
    setIsDashModalOpen(true);
  };

  const closeModal = () => {
    setIsDashModalOpen(false);
    setSelectedGroup(null);
  };

  


  return (
    <div style={{backgroundColor: 'rgb(240, 242, 245)', height: '100vh'}}>
      <div className='dashcontent'>
        <div>
          <h2>Accountability Goals</h2>
        </div>
        <div className="dashboard-container">
          <div className="stats-box" onClick={() => openModal('Impact Assessment')}>
            <div className="icon-box black">
              <PiStrategyBold />
            </div>
            <div className="content-box">
              <br></br>
              <br></br>
              <h4>Goal A1:</h4>
              <h3>Impact Assessment</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
        
          <div className="stats-box" onClick={() => openModal('Oversight of significant adverse impacts')}>
            <div className="icon-box blue">
              <FaUniversalAccess />
            </div>
            <div className="content-box">
              <br></br>
              <br></br>
              <h4>Goal A2:</h4>
              <h3>Oversight of significant adverse impacts</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>

          {/* Identifiability and Linkability */}
          <div className="stats-box" onClick={() => openModal('Fit for purpose')}>
            <div className="icon-box green">
              <PiIdentificationCardFill />
            </div>
            <div className="content-box">
              <br></br>
              <br></br>
              <h4>Goal A3:</h4>
              <h3>Fit for purpose</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
       
          {/* Security */}
          <div className="stats-box" onClick={() => openModal('Data governance and management')}>
            <div className="icon-box red">
              <AiFillSecurityScan />
            </div>
            <div className="content-box">
              <br></br>
              <br></br>
              <h4>Goal A4:</h4>
              <h3>Data governance and management</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
        </div>
        <div className="dashboard-container level2">
          {/* Safety */}
          <div className="stats-box" onClick={() => openModal('Human oversight and control')}>
            <div className="icon-box black">
              <AiFillSafetyCertificate />
            </div>
            <div className="content-box">
              <br></br>
              <br></br>
              <h4>Goal A5:</h4>
              <h3>Human oversight and control</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
        </div>
        {/* Modal for displaying the questions with recommendations */}
        <DashModal isOpen={isDashModalOpen} onClose={closeModal} selectedGroup={selectedGroup} />
      </div>
    </div>
  );
};

    

export default Accountability;